import React, { useState } from 'react';
import { Modal } from '@round/whitelabel-ui';
import { Button } from '@round/whitelabel-ui';
import { showNotification } from 'helpers';
import styles from './DeleteReportModal.module.css';

interface DeleteReportModalProps {
    isOpen: boolean;
    reportName: string;
    reportId: string;
    onDeleteReport: (publicReportId: string) => Promise<void>;
    onCancel: () => void;
}

const DeleteReportModal: React.FC<DeleteReportModalProps> = ({
    isOpen,
    reportName,
    reportId,
    onDeleteReport,
    onCancel,
}) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleConfirm = async () => {
        setIsLoading(true);
        try {
            await onDeleteReport(reportId);
            onCancel(); // Close modal on success
        } catch (error) {
            showNotification('Failed to delete shareable link', 'error');
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <Modal isOpen={isOpen} onClose={onCancel} className={styles.smallModal}>
            <Modal.Header>
                <Modal.Title>Delete Link</Modal.Title>
            </Modal.Header>
            <Modal.Body className={styles.modalBody}>
                Are you sure you want to delete "{reportName}"? This action cannot be undone.
            </Modal.Body>
            <Modal.Actions>
                <Button appearance="outline" onClick={onCancel}>
                    Cancel
                </Button>
                <Button appearance="critical" onClick={handleConfirm} disabled={isLoading} isLoading={isLoading}>
                    Delete
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

export default DeleteReportModal;
